import { ICreateAvaliacaoHabilidadeItemUseCase } from "../../../presentation/useCases/create/create_avaliacao_habilidade_item_use_case";
import { AvaliacaoHabilidade } from "../../models/avaliacao_habilidade";
import { HabilidadeItem } from "../../models/habilidade_item";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateAvaliacaoHabilidadeItemUseCase
 */

export class CreateAvaliacaoHabilidadeItemUseCase implements ICreateAvaliacaoHabilidadeItemUseCase {
  private _avaliacaoHabilidade!: AvaliacaoHabilidade;
  private _habilidades!: HabilidadeItem[];

  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createAvaliacaoHabilidadeItem(
    idAvaliacaoHabilidade: number,
    idHabilidade: number,
    nota: number,
  ): Promise<void> {
    const { avaliacaoHabilidade, habilidades } = await this.repository.createAvaliacaoHabilidadeItem(
      idAvaliacaoHabilidade,
      idHabilidade,
      nota,
    );

    this._avaliacaoHabilidade = avaliacaoHabilidade;
    this._habilidades = habilidades;
  }

  get avaliacaoHabilidade(): AvaliacaoHabilidade {
    return this._avaliacaoHabilidade;
  }

  get habilidades(): HabilidadeItem[] {
    return this._habilidades;
  }
}